<template>
  <div class="page-wrapper">
    <MainTemplate />
    <!-- Main Form Box -->
    <div class="form-card">
      <div class="form-header">入力画面</div>

      <a-form layout="vertical" class="form-content">
        <!-- 1. 証券番号 -->
        <div id="field-policyNumber" class="form-item-wrapper red-text-label">
          <CommonInput
            v-model:value="formData.policyNumber"
            label="*証券番号（半角数字・15文字以内）"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :is-policy-and-branch-no="true"
            :maxlength="16"
            @input="clearError('policyNumber')"
            @blur="handleBlur('policyNumber')"
          />
          <div v-if="errors.policyNumber" class="error-message">
            {{ errors.policyNumber }}
          </div>
        </div>

        <!-- 2. ご連絡者様のお名前 -->
        <div id="field-contactName" class="form-item-wrapper red-text-label">
          <CommonInput
            v-model:value="formData.contactName"
            label="*ご連絡者様のお名前"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            @input="clearError('contactName')"
            @blur="handleBlur('contactName')"
            :maxlength="40"
          />
          <div v-if="errors.contactName" class="error-message">
            {{ errors.contactName }}
          </div>
        </div>

        <!-- 3. ご連絡者様のお電話番号 -->
        <div id="field-contactPhone" class="form-item-wrapper red-text-label">
          <CommonInput
            v-model:value="formData.contactPhone"
            label="*ご連絡者様のお電話番号（半角数字・14文字以内）"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :is-phone-number="true"
            :maxlength="16"
            @input="clearError('contactPhone')"
            @blur="handleBlur('contactPhone')"
          />
          <div v-if="errors.contactPhone" class="error-message">
            {{ errors.contactPhone }}
          </div>
        </div>

        <!-- 4. ご契約者様との関係 -->
        <div class="form-item-wrapper flex-col">
          <label class="field-label">ご契約者様との関係</label>
          <a-select
            v-model:value="formData.relationshipWithContractor"
            class="custom-field"
            allow-clear
          >
            <a-select-option
              v-for="option in relationshipOptions"
              :key="option.key"
              :value="option.key"
            >
              {{ $t(option.description) }}
            </a-select-option>
          </a-select>
        </div>

        <!-- 5. ご契約者様のお名前(カナ) -->
        <div class="form-item-wrapper">
          <CommonInput
            v-model:value="formData.contractorNameKana"
            label="ご契約者様のお名前（カナ）"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :maxlength="70"
          />
        </div>

        <!-- 6. ご契約者様のお名前 -->
        <div class="form-item-wrapper">
          <CommonInput
            v-model:value="formData.contractorName"
            label="ご契約者様のお名前"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :maxlength="40"
          />
        </div>

        <!-- 7. ご契約者様のお電話番号 -->
        <div class="form-item-wrapper">
          <CommonInput
            v-model:value="formData.contractorPhone"
            label="ご契約者様のお電話番号（半角数字・14文字以内）"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :is-phone-number="true"
            :maxlength="16"
            title="電話番号は半角で入力してください"
          />
        </div>

        <!-- 8. 契約車両の登録番号 -->
        <div id="field-registeredVehicleNumber" class="form-item-wrapper red-text-label">
          <CommonInput
            v-model:value="formData.registeredVehicleNumber"
            label="*契約車両の登録番号（例：品川50Aあ1234）"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :is-number-plate="true"
            @input="clearError('registeredVehicleNumber')"
            @blur="handleBlur('registeredVehicleNumber')"
            :maxlength="50"
          />
          <div v-if="errors.registeredVehicleNumber" class="error-message">
            {{ errors.registeredVehicleNumber }}
          </div>
        </div>

        <!-- 9. 事故発生年月日 -->
        <div id="field-accidentDate" class="form-item-wrapper flex-col">
          <label class="field-label red-text">*【事故発生年月日】</label>
          <a-date-picker
            v-model:value="formData.accidentDate"
            placeholder="日付を選択してください"
            class="custom-field"
            format="YYYY/MM/DD"
            value-format="YYYY/MM/DD"
            :disabled-date="disabledDate"
            :input-read-only="true"
            @change="clearError('accidentDate')"
            @blur="handleBlur('accidentDate')"
          />
          <div v-if="errors.accidentDate" class="error-message">
            {{ errors.accidentDate }}
          </div>
        </div>

        <!-- 10. 事故発生時刻 -->
        <div id="field-accidentTime" class="form-item-wrapper red-text-label">
          <TimeInput
          v-model="formData.accidentTime"
          label="*【事故発生時刻】（14時30分の場合、1430と入力してください。）"
          :required="true"
          required-message="事故発生時刻を入力してください。"
          invalid-message="有効な時間を入力してください 。"
          invalid-hh-message="0 から 23 までの有効な時間を入力してください 。"
          invalid-mm-message="00 から 59 まで有効な分を入力してください 。"/>
        </div>

        <!-- 11. 事故場所 -->
        <div id="field-accidentLocation" class="form-item-wrapper red-text-label">
          <CommonInput
            v-model:value="formData.accidentLocation"
            label="*事故場所"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            @input="clearError('accidentLocation')"
            @blur="handleBlur('accidentLocation')"
            :maxlength="300"
          />
          <div v-if="errors.accidentLocation" class="error-message">
            {{ errors.accidentLocation }}
          </div>
        </div>

        <!-- 12. 運転されていた方のお名前(カナ) -->
        <div class="form-item-wrapper">
          <CommonInput
            v-model:value="formData.driverNameKana"
            label="運転されていた方のお名前（カナ）"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :maxlength="70"
          />
        </div>

        <!-- 13. 運転されていた方のお名前 -->
        <div class="form-item-wrapper">
          <CommonInput
            v-model:value="formData.driverName"
            label="運転されていた方のお名前"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :maxlength="40"
          />
        </div>

        <!-- 14. ご契約者本人 Checkbox -->
        <div class="form-item-wrapper checkbox-row">
          <a-checkbox v-model:checked="formData.isContractorHimself"> ご契約者本人 </a-checkbox>
        </div>

        <!-- 15. 性別 Select (Disabled when checkbox checked) -->
        <div class="form-item-wrapper flex-col">
          <label class="field-label">性別</label>
          <a-select
            v-model:value="formData.gender"
            class="custom-field"
            allow-clear
            :disabled="formData.isContractorHimself"
          >
            <a-select-option v-for="option in genderOptions" :key="option.key" :value="option.key">
              {{ $t(option.description) }}
            </a-select-option>
          </a-select>
        </div>

        <!-- 16. 生年月日 DatePicker (Disabled when checkbox checked) -->
        <div class="form-item-wrapper flex-col">
          <label class="field-label">【生年月日】</label>
          <a-date-picker
            placeholder="日付を選択してください"
            v-model:value="formData.birthDate"
            class="custom-field"
            format="YYYY/MM/DD"
            value-format="YYYY/MM/DD"
            :input-read-only="true"
            :disabled="formData.isContractorHimself"
            :disabled-date="disabledDate"
          />
        </div>

        <!-- 17. 年齢 (Disabled when checkbox checked) -->
        <div class="form-item-wrapper">
          <CommonInput
            v-model:value="formData.age"
            label="年齢（半角数字で入力）"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :is-age="true"
            :maxlength="3"
            :disabled="formData.isContractorHimself"
            title="年齢は半角で入力してください"
          />
        </div>

        <!-- 18. TEL (Disabled when checkbox checked) -->
        <div class="form-item-wrapper">
          <CommonInput
            v-model:value="formData.driverPhone"
            label="TEL（半角数字・14文字以内）"
            colLabel="24"
            colSpan="24"
            :maxlength="16"
            :is-custom-input="false"
            :is-phone-number="true"
            :disabled="formData.isContractorHimself"
          />
        </div>

        <!-- 19. ご契約者様との関係 -->
        <div class="form-item-wrapper flex-col">
          <label class="field-label">ご契約者様との関係</label>
          <a-select
            v-model:value="formData.driverRelationshipWithContractor"
            class="custom-field"
            allow-clear
          >
            <a-select-option
              v-for="option in driverRelationshipOptions"
              :key="option.key"
              :value="option.key"
            >
              {{ $t(option.description) }}
            </a-select-option>
          </a-select>
        </div>

        <!-- 20. 契約車両と同じ Checkbox -->
        <div class="form-item-wrapper checkbox-row">
          <a-checkbox v-model:checked="formData.isSameAsContractedVehicle">
            契約車両に同じ
          </a-checkbox>
        </div>

        <!-- 21. 事故車両登録番号 -->
        <div class="form-item-wrapper">
          <CommonInput
            v-model:value="formData.accidentVehicleNumber"
            label="事故車両登録番号（例：品川500あ1234）"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :is-number-plate="true"
            :disabled="formData.isSameAsContractedVehicle"
            :maxlength="50"
          />
        </div>

        <!-- 22. 事故状況について Textarea -->
        <div id="field-accidentDetails" class="form-item-wrapper">
          <label class="field-label">
            <span class="red-text">*事故状況について簡潔で構いませんのでご記入ください</span><br />
            例①：車対車事故。交差点を直進したところ、対向右折車両と接触した。<br />
            例②：走行中にハンドル操作を誤り、道路わきの民家の壁と接触した。
          </label>
          <CommonInput
            v-model:value="formData.accidentDetails"
            label=""
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            @input="clearError('accidentDetails')"
            @blur="handleBlur('accidentDetails')"
            :maxlength="300"
          />
          <div v-if="errors.accidentDetails" class="error-message">
            {{ errors.accidentDetails }}
          </div>
        </div>

        <!-- 23. その他連絡事項 -->
        <div class="form-item-wrapper">
          <CommonInput
            v-model:value="formData.otherNotes"
            label="その他連絡事項※ご連絡事項等ございましたらご入力ください"
            colLabel="24"
            colSpan="24"
            :is-custom-input="false"
            :maxlength="300"
          />
        </div>

        <!-- Submit Button -->
        <div class="submit-wrapper">
          <a-button @click="handleSubmit" block class="submit-btn"> 送信 </a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, reactive, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import dayjs, { Dayjs } from 'dayjs'
import CommonInput from '@/common/formControls/CommonInput.vue'
import TimeInput from '@/common/formControls/TimeInput.vue'
import {
  formatAccidentTime,
  toIdPayload,
  validateFnolForm,
  validateFnolField,
  FormValidationRules,
  SelectOption
} from '@/common/utils/CommonUtils'
import { formatDigitOnly } from '@/common/utils/newUtils/FormatUtils'
import MainTemplate from '@/components/MainTemplate.vue'

const router = useRouter()
const route = useRoute()

// Key order matching top-to-bottom layout for smooth scrolling & focus
const fieldOrder: (keyof FormValidationRules)[] = [
  'policyNumber',
  'contactName',
  'contactPhone',
  'registeredVehicleNumber',
  'accidentDate',
  'accidentTime',
  'accidentLocation',
  'accidentDetails'
]

// 性別
const genderOptions: SelectOption[] = [
  { key: 'male', id: 1, description: 'termsAndConditions.gender.male' },
  { key: 'female', id: 2, description: 'termsAndConditions.gender.female' }
]

// ご契約者様との関係
const relationshipOptions: SelectOption[] = [
  { key: 'self', id: 1, description: 'termsAndConditions.relationshipToCustomer.self' },
  { key: 'driver', id: 9, description: 'termsAndConditions.relationshipToCustomer.driver' },
  { key: 'family', id: 9, description: 'termsAndConditions.relationshipToCustomer.family' },
  { key: 'agency', id: 6, description: 'termsAndConditions.relationshipToCustomer.agency' },
  { key: 'other', id: 9, description: 'termsAndConditions.relationshipToCustomer.other' }
]

// 運転者とご契約者様との関係
const driverRelationshipOptions: SelectOption[] = [
  { key: 'self', id: 1, description: 'termsAndConditions.customerToNamedInsured.self' },
  { key: 'spouse', id: 2, description: 'termsAndConditions.customerToNamedInsured.spouse' },
  {
    key: 'childLivingTogether',
    id: 8,
    description: 'termsAndConditions.customerToNamedInsured.childLivingTogether'
  },
  {
    key: 'childNotLivingTogether',
    id: 0,
    description: 'termsAndConditions.customerToNamedInsured.childNotLivingTogether'
  },
  { key: 'family', id: 7, description: 'termsAndConditions.customerToNamedInsured.family' },
  { key: 'employee', id: 4, description: 'termsAndConditions.customerToNamedInsured.employee' },
  { key: 'friend', id: 5, description: 'termsAndConditions.customerToNamedInsured.friend' },
  { key: 'other', id: 9, description: 'termsAndConditions.customerToNamedInsured.other' }
]

interface FormState {
  policyNumber: string
  contactName: string
  contactPhone: string
  relationshipWithContractor: string
  contractorNameKana: string
  contractorName: string
  contractorPhone: string
  registeredVehicleNumber: string
  accidentDate: string | null
  accidentTime: string
  accidentLocation: string
  driverNameKana: string
  driverName: string
  isContractorHimself: boolean
  gender: string | undefined
  birthDate: string | null
  age: string
  driverPhone: string
  driverRelationshipWithContractor: string
  isSameAsContractedVehicle: boolean
  accidentVehicleNumber: string
  accidentDetails: string
  otherNotes: string
}

const formData = reactive<FormState>({
  policyNumber: '',
  contactName: '',
  contactPhone: '',
  relationshipWithContractor: '',
  contractorNameKana: '',
  contractorName: '',
  contractorPhone: '',
  registeredVehicleNumber: '',
  accidentDate: null,
  accidentTime: '',
  accidentLocation: '',
  driverNameKana: '',
  driverName: '',
  isContractorHimself: false,
  gender: undefined,
  birthDate: null,
  age: '',
  driverPhone: '',
  driverRelationshipWithContractor: '',
  isSameAsContractedVehicle: false,
  accidentVehicleNumber: '',
  accidentDetails: '',
  otherNotes: ''
})

// Validation Error State
const errors = reactive<Record<string, string>>({
  policyNumber: '',
  contactName: '',
  contactPhone: '',
  registeredVehicleNumber: '',
  accidentDate: '',
  accidentTime: '',
  accidentLocation: '',
  accidentDetails: ''
})

// Helper to map payload object { id, description } or direct string back to select option key
const getOptionKey = (options: SelectOption[], val: any): string => {
  if (!val) return ''
  if (typeof val === 'string') return val
  if (typeof val === 'object' && val.description) {
    const found = options.find((opt) => opt.description === val.description)
    return found ? found.key : ''
  }
  return ''
}

// Extract query parameters and bind to form state
const initializeFormFromQuery = () => {
  const rawData = route.query.data
  if (!rawData || typeof rawData !== 'string') return

  try {
    const data = JSON.parse(rawData)

    formData.policyNumber = data.policyNumber ?? ''
    formData.contactName = data.c1FullName ?? ''
    formData.contactPhone = data.c1Tel ?? ''
    formData.contractorNameKana = data.c1ContractNameKana ?? ''
    formData.contractorName = data.c1ContractFullName ?? ''
    formData.contractorPhone = data.c1HomeTel ?? ''
    formData.registeredVehicleNumber = data.c1RegistraNum ?? ''
    formData.accidentTime = data.c2AccidentTime ?? ''
    formData.accidentLocation = data.c2JikoPlace ?? ''
    formData.driverNameKana = data.c2DriverNameKara ?? ''
    formData.driverName = data.c2DriverFullName ?? ''
    formData.age = data.c2DriverAge ?? ''
    formData.driverPhone = data.c2DriverTel ?? ''
    formData.accidentVehicleNumber = data.c2RegistraNum ?? ''
    formData.accidentDetails = data.c2AccidentConditionText ?? ''
    formData.otherNotes = data.c2SpecialItem ?? ''

    // Date formatting using Dayjs
    formData.accidentDate = data.c2AccidentDate
      ? dayjs(data.c2AccidentDate).format('YYYY/MM/DD')
      : null
    formData.birthDate = data.c2DriverDob ? dayjs(data.c2DriverDob).format('YYYY/MM/DD') : null

    // Checkbox statuses
    formData.isContractorHimself = Boolean(data.c2DriverDobStatus) || data.c2Contracter === '1'
    formData.isSameAsContractedVehicle = Boolean(data.c2RegistraNumStatus)

    // Select Dropdown mappings
    formData.relationshipWithContractor = getOptionKey(relationshipOptions, data.c1InsuRlRelation)
    formData.gender = getOptionKey(genderOptions, data.c2Sex)
    formData.driverRelationshipWithContractor = getOptionKey(
      driverRelationshipOptions,
      data.c2InsuRlRelation
    )
  } catch (err) {
    console.error('Failed to parse URL query data:', err)
  }
}

const handleEnter = (e: KeyboardEvent) => {
  const target = e.target as HTMLElement | null
  if (!target) return

  // Allow Enter key to insert newlines inside textareas
  if (target.tagName === 'TEXTAREA') return

  // Prevent default form submit behavior
  e.preventDefault()

  const formElement = document.querySelector('.form-content')
  if (!formElement) return

  // Query all visible, non-disabled input elements in DOM order
  const focusableSelector = [
    'input:not([disabled]):not([type="hidden"])',
    'textarea:not([disabled])',
    '.ant-select-selection-search-input',
    'button:not([disabled])'
  ].join(', ')

  const focusables = Array.from(
    formElement.querySelectorAll<HTMLElement>(focusableSelector)
  ).filter((el) => el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0)

  const currentIndex = focusables.indexOf(target)

  // Move focus to the next element if available
  if (currentIndex !== -1 && currentIndex < focusables.length - 1) {
    focusables[currentIndex + 1].focus()
  }
}

onMounted(() => {
  initializeFormFromQuery()
})

const handleBlur = (field: keyof FormValidationRules) => {
  errors[field] = validateFnolField(field, formData[field])
}

const handleTimeBlur = () => {
  formData.accidentTime = formatAccidentTime(formatDigitOnly(formData.accidentTime))
  handleBlur('accidentTime')
}

const clearError = (field: string) => {
  if (errors[field]) {
    errors[field] = ''
  }
}

const focusFirstErrorField = () => {
  nextTick(() => {
    const firstErrorKey = fieldOrder.find((key) => !!errors[key])

    if (firstErrorKey) {
      const wrapperElement = document.getElementById(`field-${firstErrorKey}`)
      if (wrapperElement) {
        const inputElement = wrapperElement.querySelector<HTMLElement>(
          'input, textarea, .ant-picker, .ant-select'
        )

        if (inputElement) {
          inputElement.focus()
        }

        wrapperElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  })
}

const disabledDate = (current: Dayjs) => {
  return current && current > dayjs().endOf('day')
}

watch(
  () => formData.isContractorHimself,
  (isSelf) => {
    if (isSelf) {
      // formData.gender = undefined
      formData.birthDate = ''
      // formData.age = ''
      formData.driverPhone = formData.contactPhone || ''
    }
  }
)

watch(
  () => formData.isSameAsContractedVehicle,
  (isSelf) => {
    if (isSelf) {
      formData.accidentVehicleNumber = formData.registeredVehicleNumber || ''
    }
  }
)

const handleSubmit = () => {
  // Run validation utility
  const validation = validateFnolForm(formData)
  Object.assign(errors, validation.errors)

  if (!validation.isValid) {
    focusFirstErrorField()
    return
  }

  // Map dropdown selections to their { id, description } payload shape
  const genderPayload = toIdPayload(genderOptions, formData.gender)
  const relationshipPayload = toIdPayload(relationshipOptions, formData.relationshipWithContractor)
  const driverRelationshipPayload = toIdPayload(
    driverRelationshipOptions,
    formData.driverRelationshipWithContractor
  )

  // Construct payload object
  const payload = {
    c1FullName: (formData.contactName || '').trim(),
    c1Tel: (formData.contactPhone || '').trim(),
    c1InsuRlRelation: relationshipPayload,
    c1ContractNameKana: (formData.contractorNameKana || '').trim(),
    c1ContractFullName: (formData.contractorName || '').trim(),
    c1HomeTel: (formData.contractorPhone || '').trim(),
    c1RegistraNum: (formData.registeredVehicleNumber || '').trim(),
    c2AccidentTime: (formData.accidentTime || '').trim(),
    c2AccidentDate: formData.accidentDate ? new Date(formData.accidentDate).toISOString() : '',
    c2JikoPlace: (formData.accidentLocation || '').trim(),
    c2DriverNameKara: (formData.driverNameKana || '').trim(),
    c2DriverFullName: (formData.driverName || '').trim(),
    c2Contracter: formData.isContractorHimself ? '1' : '',
    c2Sex: genderPayload,
    c2DriverDob: (formData.birthDate || '').trim(),
    c2DriverAge: (formData.age || '').trim(),
    c2DriverTel: (formData.driverPhone || '').trim(),
    c2InsuRlRelation: driverRelationshipPayload,
    c2RegistraNum: (formData.accidentVehicleNumber || '').trim(),
    c2AccidentConditionText: (formData.accidentDetails || '').trim(),
    c2SpecialItem: (formData.otherNotes || '').trim(),
    policyNumber: (formData.policyNumber || '').trim(),
    c2RegistraNumStatus: formData.isSameAsContractedVehicle,
    c2DriverDobStatus: formData.isContractorHimself
  }

  // Redirect to /review
  router.push({
    path: '/review',
    query: {
      data: JSON.stringify(payload)
    }
  })
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.header img {
  height: 30px;
  margin: 15px 15px 15px 0;
}
.page-wrapper {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f2f2f2;
  min-height: 100vh;
  padding-top: 85px;
  padding-bottom: 30px;
}

.top-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #ffffff;
  border-bottom: 2px solid #ddd;
  padding: 8px 20px;
  margin-bottom: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* Stronger shadow */

  .top-header-title {
    font-size: 33px;
    font-weight: bold;
    color: #000000;
    text-align: start;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }
}

.form-card {
  max-width: 1100px;
  border: 2px solid #800000;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  /* Mobile default (< 768px): 5px margin around the card */
  margin: 5px;
  width: calc(100% - 10px);

  /* Desktop / Web (>= 768px): Centered with auto margins */
  @media (min-width: 768px) {
    margin: 5px auto;
    width: 100%;
  }
}

.form-card {
  max-width: 1100px;
  width: calc(100% - 10px);
  margin: 5px;
  box-sizing: border-box;
  border: 2px solid #800000;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
@media (min-width: 1110px) {
  .form-card {
    margin: 5px auto;
  }
}

.form-header {
  background-color: #800000;
  color: #ffffff;
  font-weight: bold;
  font-size: 20px;
  text-align: start;
  padding: 6px 5px;
  border-radius: 4px;
  margin-bottom: 12px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

.form-content {
  padding: 0 4px;
}

.form-item-wrapper {
  margin-bottom: 12px;
  text-align: left;
}

.flex-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.checkbox-row {
  padding-left: 2px;
  margin-top: 6px;
  margin-bottom: 12px;
}

/* Error Message Styling */
.error-message {
  color: #dc3545;
  font-size: 14px;
  margin-top: 0px;
  text-align: left;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

/* Base field labels - 16px minimum */
.field-label {
  font-size: 16px !important;
  color: #333333;
  margin-bottom: 4px;
  text-align: left;
  display: block;
  width: 100%;
  line-height: 1.4;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

.red-text {
  color: #cc0000 !important;
}

/* CommonInput Labels Override - 16px minimum */
:deep(.custom-label) {
  text-align: left !important;
  justify-content: flex-start !important;
  font-size: 16px !important;
  padding-bottom: 2px !important;
  color: #333333;
  line-height: 1.4 !important;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
}

:deep(.red-text-label .custom-label) {
  color: #cc0000 !important;
}

/* Ant Design Checkbox Label Override - 16px minimum */
:deep(.ant-checkbox-wrapper) {
  font-size: 16px !important;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
}

/* Remove Ant Design Form Item margins */
:deep(.ant-form-item) {
  width: 100% !important;
  margin-bottom: 0 !important;
}

/* --- FIX DOUBLE BORDER / RINGS & STYLE INPUTS --- */

/* Outer container border and font size */
:deep(.ant-input-affix-wrapper),
:deep(.ant-picker),
:deep(.ant-select-selector),
:deep(input.ant-input:not(.ant-input-affix-wrapper input)),
:deep(textarea.ant-input) {
  border: 1px solid #d9d9d9 !important;
  border-radius: 3px !important;
  box-shadow: none !important;
  outline: none !important;
  background-color: #ffffff !important;
  font-size: 16px !important;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
}

/* Inner input inside affix wrapper */
:deep(.ant-input-affix-wrapper input.ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
  height: 100% !important;
  padding: 0 !important;
  font-size: 16px !important;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
}

:deep(.ant-select-item-option-content) {
  font-size: 16px !important;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
}

/* Input heights */
:deep(.ant-input-custom),
:deep(.custom-field) {
  height: 30px !important;
  width: 100% !important;
}

:deep(.custom-textarea) {
  height: auto !important;
  min-height: 84px !important;
}

/* --- GREY OUT STYLES FOR DISABLED FIELDS --- */

:deep(.ant-input-affix-wrapper-disabled),
:deep(.ant-picker-disabled),
:deep(.ant-select-disabled .ant-select-selector),
:deep(input.ant-input:disabled),
:deep(textarea.ant-input:disabled) {
  background-color: #eef1f6 !important; /* Grey background */
  border-color: #d0d5dd !important; /* Soft grey border */
  cursor: not-allowed !important;
}

:deep(.ant-input-affix-wrapper-disabled input.ant-input),
:deep(.ant-select-disabled),
:deep(.ant-picker-disabled input) {
  color: #8c8c8c !important; /* Dimmed text color */
  cursor: not-allowed !important;
}

/* Submit Button */
.submit-wrapper {
  margin-top: 16px;
}

.submit-btn {
  background-color: #118b50 !important;
  border-color: #118b50 !important;
  color: white;
  height: 44px;
  font-size: 18px !important;
  border-radius: 4px;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;

  &:hover,
  &:focus {
    color: white;
    background-color: #0e7342 !important;
    border-color: #0e7342 !important;
  }
}
:deep(.ant-picker-input > input) {
  font-size: 16px !important;
  padding-top: 4px;
}

/* Target standard CommonInput / Ant Design inputs */
:deep(.ant-input) {
  font-size: 16px !important;
}

/* Target Select dropdown display text */
:deep(.ant-select-single .ant-select-selector) {
  font-size: 16px !important;
}
</style>
